// extracted by mini-css-extract-plugin
export default {"planTilesScroller":"PlanTiles_planTilesScroller__6g0gJ"};